export default function WhyPhoneSalesFail() {
  const mistakes = [
    { icon: 'ri-file-text-line', text: 'Чтение скрипта — клиент слышит робота, а не живого человека' },
    { icon: 'ri-speed-up-line', text: 'Слишком ранняя презентация — менеджер продаёт до того, как понял клиента' },
    { icon: 'ri-user-unfollow-line', text: 'Отсутствие интереса к клиенту — разговор про продукт, а не про потребность' },
    { icon: 'ri-emotion-unhappy-line', text: 'Страх возражений — менеджер теряется при первом отказе' },
    { icon: 'ri-pushpin-line', text: 'Попытка продавить — давление вызывает защиту и отторжение' },
    { icon: 'ri-speak-line', text: 'Монолог вместо диалога — менеджер говорит 80% времени' },
    { icon: 'ri-shuffle-line', text: 'Отсутствие управления разговором — клиент уводит беседу в сторону' },
    { icon: 'ri-door-open-line', text: 'Завершение без следующего шага — звонок закончен, сделки нет' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему большинство телефонных продаж не работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Большинство менеджеров совершают одни и те же ошибки — и теряют клиентов, даже не осознавая этого. Разберём ключевые проблемы и покажем, как их исправить.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-16">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white border border-red-100 rounded-xl p-5 hover:border-red-200 transition-colors group">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-red-100 transition-colors">
                <i className={`${item.icon} text-red-500 text-lg`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-lightbulb-line text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Телефон продаёт не потому, что менеджер много говорит. Телефон продаёт тогда, когда менеджер управляет решением клиента.
          </p>
        </div>
      </div>
    </section>
  );
}